import { useLocation } from "react-router-dom";
import PageSeo from "./PageSeo";
import { DEFAULT_SITE_DESCRIPTION, isPrivateAppRoute } from "../lib/pageSeo";

/**
 * Applies noindex meta on authenticated workspace and dev routes that do not
 * define their own PageSeo (sign-in, marketing, and public job pages set SEO explicitly).
 */
export default function RouteSeoFallback() {
  const { pathname } = useLocation();
  if (!isPrivateAppRoute(pathname)) return null;

  return (
    <PageSeo
      title="JOBUWIN"
      description={DEFAULT_SITE_DESCRIPTION}
      path={pathname}
      noindex
    />
  );
}
